//Api handler
import axios from 'axios';
//Stacks lib imports
import { useConnect } from '@stacks/connect-react';
import {
    cvToValue, makeStandardFungiblePostCondition, PostConditionMode, createAssetInfo, FungibleConditionCode, AnchorMode, stringUtf8CV, someCV, noneCV, uintCV,
    callReadOnlyFunction, makeStandardSTXPostCondition, stringAsciiCV, cvToString, principalCV, principalToString, trueCV, falseCV, bufferCVFromString, hexToCV, cvToJSON, tupleCV, listCV
} from '@stacks/transactions';
//React imports
import { useEffect, useState } from 'react';
//User defined imports
import { getUserData, network, authenticatedUserAddress, isUserSignedIn, userBalance } from './auth';
// MUI Imports;
import Button from '@mui/material/Button';
//
import { contractDeployer, cryptoCashCoreAddress, deruptFeedContractAddress, sentimentOptions, stacksApi, sentimentApi, cryptoCashTokenAddress, clientNetwork } from '../lib/constants';
import { optionalCVOf } from '@stacks/transactions/dist/clarity/types/optionalCV';

//Stacks network handler
import { cityCoins } from '../lib/currency';
import { Badge, Menu, MenuItem } from '@mui/material';
import { BsHeart, BsHeartFill, BsHeartbreak, BsHeartbreakFill } from 'react-icons/bs';
import { PiChats, PiChatsFill } from 'react-icons/pi';
import { fees } from '../lib/fees';
import { SlPuzzle } from "react-icons/sl";

const appOrigin = window.location.origin;

let userAddress;
if (isUserSignedIn()) {
    userAddress = authenticatedUserAddress({ network: clientNetwork });
}

export const getBlockDifference = async () => {
    if (!userAddress) return false;
    try {
        const currentBlock = (await axios.get(`${stacksApi}/extended/v2/blocks/`)).data.results[0]['height'];
        const mempoolTx = (await axios.get(`${stacksApi}/extended/v1/tx/mempool?address=${userAddress}`)).data.results;
        for (let i = 0; i < mempoolTx.length; i++) {
            if (mempoolTx[i].tx_type === "contract_call") {
                const { contract_call: { contract_id, function_name } } = mempoolTx[i];
                return contract_id === `${userAddress}.derupt-profile` && (function_name === 'send-message' || function_name === 'favorable-reply-message' || function_name === 'unfavorable-reply-message');
            }
        }
        const previouseTxDetails = (await axios.get(`${stacksApi}/extended/v2/addresses/${userAddress}/transactions?offset=0&limit=30`)).data.results;
        for (let i = 0; i < previouseTxDetails.length; i++) {
            if (previouseTxDetails[i]?.tx?.tx_type === "contract_call") {
                const { tx_id, contract_call: { contract_id, function_name } } = previouseTxDetails[i].tx;
                if (contract_id === `${userAddress}.derupt-profile` && (function_name === 'send-message' || function_name === 'favorable-reply-message' || function_name === 'unfavorable-reply-message')) {
                    const txEvents = (await axios.get(`${stacksApi}/extended/v1/tx/events?tx_id=${tx_id}`)).data;
                    if (txEvents.events) {
                        const { events } = txEvents;
                        for (let x = 0; x < events.length; x++) {
                            if (events[x]?.contract_log && events[x]?.event_type === 'smart_contract_log') {
                                const { contract_log: { contract_id, value: { hex } } } = events[x];
                                if (contract_id === cryptoCashCoreAddress) {
                                    const { lastBlock } = cvToJSON(hexToCV(hex))?.value
                                    return lastBlock?.value > currentBlock;
                                }
                            }
                        }
                    }
                }
            }

        }
    } catch (error) {
        return false
    }

}

// Get Interface Info
export const getInterfaceInfo = async () => {
    if (!userAddress) return null;
    try {
        console.log('appOrigin', appOrigin);

        const info = await callReadOnlyFunction({
            contractAddress: contractDeployer,
            contractName: 'derupt-interfaces',
            functionName: 'get-token-interface',
            functionArgs: [stringUtf8CV(appOrigin)],
            senderAddress: userAddress,
            network: network({ network: clientNetwork })
        });
        const {
            "dev-ft-amount": devFtAmount,
            "dev-principal": devPrincipal,
            "dev-stx-amount": devStxAmount,
            "gaia-ft-amount": gaiaFtAmount,
            "gaia-principal": gaiaPrincipal,
            "gaia-stx-amount": gaiaStxAmount,
            "pay-dev": payDev, "pay-gaia": payGaia
        } = info?.value?.value?.data;
        return {
            payDev: cvToValue(payDev), payGaia: cvToValue(payGaia),
            devFtAmount: cvToString(devFtAmount).replace('u', ''), gaiaFtAmount: cvToString(gaiaFtAmount).replace('u', ''),
            devStxAmount: cvToString(devStxAmount).replace('u', ''), gaiaStxAmount: cvToString(gaiaStxAmount).replace('u', ''),
            devPrincipal: cvToString(devPrincipal), gaiaPrincipal: cvToString(gaiaPrincipal)
        }
    } catch (error) {
        console.log('The DeruptCoreContract Error', error);
    }
}

// Get Core (privately)
export const getDeruptCoreContractPrivately = async (userSettings) => {
    if (!userAddress) return '';
    try {
        let data = JSON.stringify({ "sender": userAddress, "arguments": [] });
        let config = {
            method: 'post', maxBodyLength: Infinity,
            url: `${userSettings?.stacksApi || stacksApi}/v2/contracts/call-read/${deruptFeedContractAddress.split('.')[0]}/${deruptFeedContractAddress.split('.')[1]}/get-derupt-core-contract`,
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, data: data
        };
        const { data: { result } } = await axios.request(config);
        return cvToJSON(hexToCV(result)).value?.value;
    } catch (error) {
        console.log('The DeruptCoreContract Error', error);
        return '';
    }
};

// Get Core (publically)
export const getDeruptCoreContractPublically = async (userSettings) => {
    try {
        const genericAddress = 'ST180A283Q28Q7PT7B7CJC1M11YEJQBNYYDMQRATG';
        //const genericAddress = 'SP000000000000000000002Q6VF78';
        let data = JSON.stringify({ "sender": genericAddress, "arguments": [] });
        let config = {
            method: 'post', maxBodyLength: Infinity,
            url: `${userSettings?.stacksApi || stacksApi}/v2/contracts/call-read/${deruptFeedContractAddress.split('.')[0]}/${deruptFeedContractAddress.split('.')[1]}/get-derupt-core-contract`,
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, data: data
        };
        const { data: { result } } = await axios.request(config);
        return cvToJSON(hexToCV(result)).value?.value;
    } catch (error) {
        console.log('The DeruptCoreContract Error', error);
        return '';
    }
};

// Get NFT Owner (publically)
export const getNftOwnerPublically = async ({ contract, id }) => {
    try {
        const nftOwner = await callReadOnlyFunction({
            contractAddress: contract.split('.')[0],
            contractName: contract.split('.')[1].split('::')[0],
            functionName: 'get-owner',
            functionArgs: [
                uintCV(id) // pass in the nft id as a uint
            ],
            network: network({ network: clientNetwork }),
            senderAddress: 'ST180A283Q28Q7PT7B7CJC1M11YEJQBNYYDMQRATG',
        });
        return principalToString(nftOwner.value.value);
    } catch (error) {
        console.log(error);
        return null;
    }
};

// Get Sentiment (agnostic)
export const getMessageSentiment = async (txId, who, userSettings) => {
    try {
        const response = await axios.get(`${userSettings?.sentimentApi || sentimentApi}/sentiment?txid=${txId}&who=${who}`, {
            httpAgent: false,
            httpsAgent: false
        });
        const sentiment = response.data;
        return sentiment;
    } catch (error) {
        console.error('Error fetching sentiment:', error);
    }
};

// Get Costs (privately)
export const getCosts = async () => {
    if (!userAddress) return null;
    try {
        const senderAddress = userAddress;
        const options = {
            contractAddress: deruptFeedContractAddress.split('.')[0],
            contractName: deruptFeedContractAddress.split('.')[1],
            functionName: "view-cost", functionArgs: [], network: network({ network: clientNetwork }), senderAddress
        };
        const { value: { value: { data } } } = await callReadOnlyFunction(options);
        return {
            chimeFtCost: data['chime-ft-cost']?.value?.value,
            chimeStxCost: data['chime-stx-cost']?.value?.value,
            dislikeFtCost: data['dislike-ft-cost']?.value?.value,
            likeFtCost: data['like-ft-cost']?.value?.value
        }
    } catch (error) {
        console.log('Caught', error);
    }
};

// Post gift-message (privately)
export const UseGiftMessage = ({ token, authorPrincipal, amount, memo, disabled, setCurrentTxId, setShowConfirmModal, giftVia }) => {
    const { doContractCall } = useConnect();
    const gift = async () => {
        if (!userAddress) return;
        const postConditionAddress = userAddress;
        const userContract = `${postConditionAddress}.derupt-profile`;
        const postConditionAmount = amount * token.decimalfactor;
        const postConditionCode = FungibleConditionCode.Equal;
        const deruptCoreContract = await getDeruptCoreContractPrivately();
        let postConditions;
        if (token.value === 'stx') {
            postConditions = [makeStandardSTXPostCondition(postConditionAddress, postConditionCode, postConditionAmount)];
        } else {
            const postFtConditionAssetInfo = createAssetInfo(token.ftaddress.split('.')[0], token.ftaddress.split('.')[1].split('::')[0], token.ftaddress.split('::')[1]);
            postConditions = [makeStandardFungiblePostCondition(postConditionAddress, postConditionCode, postConditionAmount, postFtConditionAssetInfo)];
        }
        const txOptions = {
            contractAddress: userContract.split('.')[0],
            contractName: userContract.split('.')[1],
            functionName: 'gift-message',
            functionArgs: [
                principalCV(authorPrincipal),
                uintCV(postConditionAmount),
                stringUtf8CV(giftVia),
                token.value === 'stx' ? trueCV(true) : falseCV(false),
                token.value === 'stx' ? principalCV(cryptoCashTokenAddress) : principalCV(`${token.ftaddress.split('::')[0]}`),
                principalCV(deruptCoreContract),
                memo ? someCV(bufferCVFromString(memo)) : noneCV()
            ],
            network: network({ network: clientNetwork }),
            validateWithAbi: true,
            anchorMode: AnchorMode.Any,
            postConditions,
            onFinish: ({ txId }) => {
                setCurrentTxId(txId);
                setShowConfirmModal(true);
            },
            onCancel: () => {
                console.log("Action aborted");
            }
        };
        doContractCall(txOptions);
    };

    return (
        <Button className="button" disabled={disabled} variant="contained" onClick={gift}>Gift</Button>
    );
};

// Post send-message (privately)
export const SendMessageCall = ({ chimeBtn, chimeContent, setShowConfirmModal, setTxId, blocks, stxInput, setOpenSnackBar, setErrorMsg }) => {
    const { doContractCall } = useConnect();
    const makeCall = async () => {
        try {
            const { payDev, payGaia, devStxAmount, devFtAmount, gaiaStxAmount, gaiaFtAmount } = await getInterfaceInfo();
            const { getSendMessageTotal } = await fees(stxInput, payDev, payGaia, devStxAmount, devFtAmount, gaiaStxAmount, gaiaFtAmount);
            const deruptCoreContract = await getDeruptCoreContractPrivately();

            const { content, attachmentUri, thumbnailUri } = chimeContent;
            const { stx_grand_total } = getSendMessageTotal();
            // This retrieve's and compare's user balance if users 
            // meets required balance to execute this function
            const usersBalance = await userBalance({ token_asset_id: cryptoCashTokenAddress });
            if (usersBalance['stx'] < stx_grand_total) {
                setErrorMsg('Insufficient STX Token Balance');
                setOpenSnackBar(true);
                return;
            }
            const postConditionAddress = userAddress;
            const postConditionCode = FungibleConditionCode.LessEqual;
            const postConditionAmount = stx_grand_total;

            const standardSTXPostCondition = makeStandardSTXPostCondition(
                postConditionAddress,
                postConditionCode,
                postConditionAmount
            );

            const attachmentCV_Value = attachmentUri ? optionalCVOf(stringUtf8CV(attachmentUri)) : noneCV();
            const thhumbnailCV_Value = thumbnailUri ? optionalCVOf(stringUtf8CV(thumbnailUri)) : noneCV();
            doContractCall({
                network: network({ network: clientNetwork }),
                anchorMode: AnchorMode.Any,
                contractAddress: userAddress,
                contractName: 'derupt-profile',
                functionName: 'send-message',
                functionArgs: [
                    stringUtf8CV(content),
                    attachmentCV_Value,
                    thhumbnailCV_Value,
                    noneCV(),
                    listCV(Array.from({ length: blocks }, (_, index) => uintCV(Math.floor((stxInput * 1000000) / blocks)))),
                    stringUtf8CV(appOrigin),
                    noneCV(),
                    noneCV(),
                    principalCV(deruptCoreContract)
                ],
                postConditionMode: PostConditionMode.Deny,
                postConditions: [standardSTXPostCondition],
                stxAddress: userAddress,
                onFinish: ({ txId }) => {
                    setTxId(txId);
                    setShowConfirmModal(true);
                }
            });
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Button id="chime-button" variant="contained" onClick={() => makeCall()} disabled={chimeBtn} size="medium">Chime</Button>
    );
};

// Post favorable-reply-message calling or unfavorable-reply-message (privately)
export const ReplySendMessageCall = ({ chimeAuthor, chimeBtn, chimeContent, chimeTx, sentimentOptions, setShowConfirmModal, setTxId, setOpenSnackBar, setErrorMsg, stxInput, blocks, likeFtAmount, dislikeFtAmount }) => {
    const [buttonLabel, setButtonLabel] = useState('');
    const { doContractCall } = useConnect();

    const makeCall = async () => {
        const { value } = sentimentOptions;
        const { likeFtCost, dislikeFtCost } = await getCosts();
        const { content, attachmentUrl, thumbnailUrl } = chimeContent;
        const { stx_grand_total, ft_grand_total } = (value === "favorable")
            ? (await fees(stxInput)).getFavorableReplyMessageTotal()
            : (await fees(stxInput)).getUnfavorabelReplyMessageTotal();

        // This retrieve's and compare's user balance if users 
        // meets required balance to execute this function
        const usersBalance = await userBalance({ token_asset_id: cryptoCashTokenAddress });
        if (usersBalance['stx'] < stx_grand_total) {
            setErrorMsg('Insufficient STX Token Balance');
            setOpenSnackBar(true);
            return;
        }
        console.log({ ccbalance: usersBalance[cryptoCashTokenAddress], ft_grand_total });
        if (parseInt(usersBalance[cryptoCashTokenAddress]) < ft_grand_total) {
            setErrorMsg('Insufficient Fungible Token Balance');
            setOpenSnackBar(true);
            return;
        }

        try {
            const { at_url } = attachmentUrl || '';
            const { th_url } = thumbnailUrl || '';
            const deruptCoreContract = await getDeruptCoreContractPrivately();
            const postConditionAddress = userAddress;
            const postConditionCode = FungibleConditionCode.LessEqual;
            const postStxConditionAmount = stx_grand_total;
            const postFtConditionAmount = ft_grand_total;
            const postConditionAssetInfo = createAssetInfo(cryptoCashTokenAddress.split('.')[0], cryptoCashTokenAddress.split('.')[1].split('::')[0], cryptoCashTokenAddress.split('::')[1]);
            const postConditions = [
                makeStandardSTXPostCondition(postConditionAddress, postConditionCode, postStxConditionAmount),
                makeStandardFungiblePostCondition(postConditionAddress, postConditionCode, postFtConditionAmount, postConditionAssetInfo)
            ];

            const attachmentUri = at_url ? optionalCVOf(stringUtf8CV(at_url)) : noneCV();
            const thumbnailUri = th_url ? optionalCVOf(stringUtf8CV(th_url)) : noneCV();
            const txOptions = {
                contractAddress: userAddress,
                contractName: 'derupt-profile',
                functionName: sentimentOptions.functionName,
                functionArgs: sentimentOptions.value === 'favorable'
                    ? [
                        stringUtf8CV(content),
                        attachmentUri,
                        thumbnailUri,
                        stringUtf8CV(chimeTx),
                        principalCV(chimeAuthor),
                        stringUtf8CV(chimeTx),
                        listCV(Array.from({ length: blocks }, (_, index) => uintCV(Math.floor((stxInput * 1000000) / blocks)))),
                        stringUtf8CV(appOrigin),
                        noneCV(),
                        noneCV(),
                        principalCV(cryptoCashTokenAddress.split('::')[0]),
                        principalCV(`${deruptCoreContract}`),
                        uintCV(likeFtAmount || likeFtCost)
                    ]
                    : [
                        stringUtf8CV(content),
                        attachmentUri,
                        thumbnailUri,
                        stringUtf8CV(chimeTx),
                        principalCV(chimeAuthor),
                        stringUtf8CV(chimeTx),
                        listCV(Array.from({ length: blocks }, (_, index) => uintCV(Math.floor((stxInput * 1000000) / blocks)))),
                        stringUtf8CV(appOrigin),
                        noneCV(),
                        noneCV(),
                        principalCV(`${cryptoCashTokenAddress.split('::')[0]}`),
                        principalCV(`${deruptCoreContract}`),
                        uintCV(dislikeFtAmount || dislikeFtCost),
                        uintCV(1)
                    ],
                validateWithAbi: true,
                network: network({ network: clientNetwork }),
                postConditions,
                anchorMode: AnchorMode.Any,
                onFinish: ({ txId }) => {
                    setTxId(txId);
                    setShowConfirmModal(true);
                }
            };
            doContractCall(txOptions);
        } catch (err) {
            setErrorMsg('An unexpected error occured');
            setOpenSnackBar(true);
        }
    };

    useEffect(() => {
        let label = String(sentimentOptions.functionName).replace('-', ' ').replace('-', ' ').replace('message', '');
        setButtonLabel(label);
    }, [buttonLabel, sentimentOptions]);

    return (
        <>
            <Button id="chime-button" variant="contained" onClick={makeCall} disabled={chimeBtn} size="medium">{buttonLabel}</Button>
        </>
    );
};

export const ReplyMessageMenue = ({ replyCounts, replied, validating, setSentimentOptions, ChimeAuthorPrincipal, setSelectedAuthorPrincipal, setShowReplyChimeModal, setTx_Id, Tx_ID, setReplyOpen, setOpenSnackBar, setErrorMsg }) => {
    const [anchorReplyMenue, setAnchorReplyMenue] = useState(null);
    const [openReplyMenue, setOpenReplyMenue] = useState(false);

    const handleReplyMenueClick = (e) => {
        setReplyOpen(true);
        setAnchorReplyMenue(e.currentTarget);
        validating(setOpenReplyMenue, true);
        console.log('fired');
    };

    const handleCloseReplyMenue = () => {
        setOpenReplyMenue(false);
    };

    async function handleReplySentimentClick(option) {
        // This checks if users is interacting with personal chime content
        if (userAddress === ChimeAuthorPrincipal) {
            setErrorMsg("Interacting with your own content is not possible");
            setOpenSnackBar(true);
            return null;
        }
        // Final state setter's
        setSentimentOptions(option);
        setSelectedAuthorPrincipal(ChimeAuthorPrincipal);
        setTx_Id(Tx_ID);
        setShowReplyChimeModal(true);
        handleCloseReplyMenue();
    }

    return (
        <div>
            <button className="derupt-button" onClick={handleReplyMenueClick}>
                <Badge badgeContent={replyCounts} color="warning" anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }}>{replied ? <PiChatsFill size={24} /> : <PiChats size={24} />}</Badge>
            </button>
            <Menu id="basic-menu" anchorEl={anchorReplyMenue} open={openReplyMenue} onClose={handleCloseReplyMenue} MenuListProps={{ 'aria-labelledby': 'basic-button' }}>
                {
                    sentimentOptions.map(option => {
                        return (
                            <MenuItem key={option.value} onClick={() => handleReplySentimentClick(option)}>
                                {option.icon}
                            </MenuItem>
                        )
                    })
                }
            </Menu>
        </div>
    );
};

export const LikeMessageCall = ({ setOpenExtensionModal, likeCounts, liked, validating, ChimeAuthorPrincipal, Tx_ID, setErrorMsg, setOpenSnackBar, setTx_Id, setOpenConfirmModal, userSettings, likeFtAmount }) => {
    const [anchorLike, setAnchorLike] = useState(null);
    const [openLike, setOpenLike] = useState(false);
    const { doContractCall } = useConnect();

    const handleOpenExtensionModal = () => {
        setOpenExtensionModal(true);
        setOpenLike(false);
    };
    const handleLikeClick = (e) => {
        setAnchorLike(e.currentTarget);
        validating(setOpenLike, true);
    };
    // const handleLikeWithExtensionClick = (e) => {
    //     setErrorMsg('Extension options coming soon');
    //     setOpenSnackBar(true);
    // };

    const handleCloseLikeMenue = () => { setOpenLike(false) };

    const doLikeMessageCall = async (txId) => {
        handleCloseLikeMenue();
        if (userAddress === ChimeAuthorPrincipal) {
            setErrorMsg("Interacting with your own content is not possible");
            setOpenSnackBar(true);
            return;
        }
        // This retrieve's and compare's user balance if users 
        // meets required balance to execute this function
        const { likeFtCost } = await getCosts();
        const { ft_grand_total } = (await fees(0)).getLikeMessageTotal();
        const usersBalance = await userBalance({ token_asset_id: cryptoCashTokenAddress });
        if ((usersBalance[cryptoCashTokenAddress] || 0) < ft_grand_total) {
            setErrorMsg('Insufficient Fungible Token Balance');
            setOpenSnackBar(true);
            return;
        }
        // Function postconditions
        const postConditionCode = FungibleConditionCode.LessEqual;
        const postConditionAmount = ft_grand_total;
        const postConditionAssetInfo = createAssetInfo(cryptoCashTokenAddress.split('.')[0], cryptoCashTokenAddress.split('.')[1].split('::')[0], cryptoCashTokenAddress.split('::')[1]);
        const postConditions = [
            makeStandardFungiblePostCondition(userAddress, postConditionCode, postConditionAmount, postConditionAssetInfo),
        ];

        const deruptCoreContract = await getDeruptCoreContractPrivately();

        doContractCall({
            contractAddress: userAddress,
            contractName: 'derupt-profile',
            functionName: 'like-message',
            functionArgs: [
                principalCV(ChimeAuthorPrincipal),
                stringUtf8CV(txId),
                principalCV(cryptoCashTokenAddress.split('::')[0]),
                principalCV(deruptCoreContract),
                uintCV(likeFtAmount || likeFtCost),
                stringUtf8CV(appOrigin),
                noneCV(),
                noneCV()
            ],
            network: network({ network: clientNetwork }),
            validateWithAbi: true,
            anchorMode: AnchorMode.Any,
            postConditions,
            onFinish: ({ txId }) => {
                setTx_Id(txId);
                setOpenConfirmModal(true);
            },
            onCancel: () => {
                console.log("Action aborted");
            }
        });
    };

    return (
        <div>
            <button className="derupt-button" id="basic-button" aria-controls={openLike ? 'basic-menu' : false} aria-haspopup="true" aria-expanded={openLike ? 'true' : false} onClick={handleLikeClick}>
                <Badge badgeContent={likeCounts} color="warning" anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }}>{liked ? <BsHeartFill size={24} /> : <BsHeart size={24} />}</Badge>
            </button>
            <Menu id="basic-menu" anchorEl={anchorLike} open={openLike} onClose={handleCloseLikeMenue} MenuListProps={{ 'aria-labelledby': 'basic-button' }}>
                <MenuItem disabled={liked} onClick={() => doLikeMessageCall(Tx_ID)}><img src={`${window.location.origin}/32-cc.png`} alt='' /></MenuItem>
                <MenuItem><SlPuzzle id="extension-icon" onClick={handleOpenExtensionModal} size={32} /></MenuItem>
            </Menu>
        </div>
    );
};

export const DislikeMessageCall = ({ setOpenExtensionModal, disLikeCounts, disliked, validating, ChimeAuthorPrincipal, Tx_ID, setErrorMsg, setOpenSnackBar, setTx_Id, setOpenConfirmModal, userSettings, dislikeFtAmount }) => {
    const [anchorDislike, setAnchorDislike] = useState(null);
    const [openDislike, setOpenDislike] = useState(false);

    const { doContractCall } = useConnect();

    const handleOpenExtensionModal = () => {
        setOpenExtensionModal(true);
        setOpenDislike(false);
    };

    const handleDislikeClick = (e) => {
        setAnchorDislike(e.currentTarget);
        validating(setOpenDislike, true);
    };
    // const handleDislikeWithExtensionClick = (e) => {
    //     setErrorMsg('Extension options coming soon');
    //     setOpenSnackBar(true);
    // };

    const handleCloseDisikeMenue = () => { setOpenDislike(false) };

    const doDislikeMessageCall = async (txId) => {
        if (userAddress === ChimeAuthorPrincipal) {
            setErrorMsg("Interacting with your own content is not possible");
            setOpenSnackBar(true);
            return;
        }
        handleCloseDisikeMenue();
        // This retrieve's and compare's user balance if users 
        // meets required balance to execute this function
        const { dislikeFtCost } = await getCosts();
        const { ft_grand_total } = (await fees(0)).getDislikeMessageTotal();
        const usersBalance = await userBalance({ token_asset_id: cryptoCashTokenAddress });
        if ((usersBalance[cryptoCashTokenAddress] || 0) < ft_grand_total) {
            setErrorMsg('Insufficient Fungible Token Balance');
            setOpenSnackBar(true);
            return;
        }
        // Function postconditions
        const postConditionCode = FungibleConditionCode.LessEqual;
        const postConditionAmount = ft_grand_total;
        const postConditionAssetInfo = createAssetInfo(cryptoCashTokenAddress.split('.')[0], cryptoCashTokenAddress.split('.')[1].split('::')[0], cryptoCashTokenAddress.split('::')[1]);
        const postConditions = [
            makeStandardFungiblePostCondition(userAddress, postConditionCode, postConditionAmount, postConditionAssetInfo),
        ];

        const deruptCoreContract = await getDeruptCoreContractPrivately();

        doContractCall({
            contractAddress: userAddress,
            contractName: 'derupt-profile',
            functionName: 'dislike-message',
            functionArgs: [
                principalCV(ChimeAuthorPrincipal),
                stringUtf8CV(txId),
                principalCV(cryptoCashTokenAddress.split('::')[0]),
                principalCV(deruptCoreContract),
                uintCV(dislikeFtAmount || dislikeFtCost),
                uintCV(1),
                stringUtf8CV(appOrigin),
                noneCV(),
                noneCV()
            ],
            network: network({ network: clientNetwork }),
            validateWithAbi: true,
            anchorMode: AnchorMode.Any,
            postConditions,
            onFinish: ({ txId }) => {
                setTx_Id(txId);
                setOpenConfirmModal(true);
            },
            onCancel: () => {
                console.log("Action aborted");
            }
        });
    };

    return (
        <div>
            <button className="derupt-button" id="basic-button" aria-controls={anchorDislike ? 'basic-menu' : false} aria-haspopup="true" aria-expanded={anchorDislike ? 'true' : false} onClick={handleDislikeClick}>
                <Badge badgeContent={disLikeCounts} color="warning" anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }}>{disliked ? <BsHeartbreakFill size={24} /> : <BsHeartbreak size={24} />}</Badge>
            </button>
            <Menu id="basic-menu" anchorEl={anchorDislike} open={openDislike} onClose={handleCloseDisikeMenue} MenuListProps={{ 'aria-labelledby': 'basic-button' }}>
                <MenuItem disabled={disliked} onClick={() => doDislikeMessageCall(Tx_ID)}><img src={`${window.location.origin}/32-cc.png`} alt='' /></MenuItem>
                <MenuItem><SlPuzzle id="extension-icon" onClick={handleOpenExtensionModal} size={32} /></MenuItem>
            </Menu>
        </div>
    );
};